<template>
  <div class="header">
    <div>
      <!-- <img
          src='../assets/heima.png'
          alt=''
        /> -->
      <span>信息学基地管理系统</span>
    </div>
    <div>
      <!-- <i class="iconfont icon-gonggao1"></i><p class="microsoft marquee">滚动字幕</p> -->
    </div>
    <div class="avatar">
      <Logout></Logout>
    </div>
  </div>
</template>

<script>
import Logout from 'common/logout/Logout';
export default {
  name: 'home_header',
  data() {
    return {};
  },
  components: {
    Logout
  }
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 100%;
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
}

.header div {
  display: flex;
  align-items: center;
}

.header div span {
  margin-left: 15px;
}
.avatar {
  margin-right: 10px;
}
/* 滚动字幕 */
.marquee {
  width: 450px;
  margin: 0 auto;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  animation: marquee 50s linear infinite;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move */
@keyframes marquee {
  0% {
    text-indent: 27.5em;
  }
  100% {
    text-indent: -105em;
  }
}

/* Make it pretty */
.microsoft {
  padding-left: 1.5em;
  position: relative;
  font: 16px "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}

/* ::before was :before before ::before was ::before - kthx
.microsoft:before,
.microsoft::before {
  z-index: 2;
  content: "";
  position: absolute;
  top: -1em;
  left: -1em;
  width: 0.5em;
  height: 0.5em;
  box-shadow: 1em 1.25em 0 #f65314, 1.6em 1.25em 0 #7cbb00, 1em 1.85em 0 #00a1f1,
    1.6em 1.85em 0 #ffbb00;
}

.microsoft:after,
.microsoft::after {
  z-index: 1;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 2em;
  height: 2em;
  background-image: linear-gradient(90deg, white 70%, rgba(255, 255, 255, 0));
} */
</style>